import { useSelector } from 'react-redux';
import { ApplicationState } from '@mews-commander/types';
import { useResolveRoute } from '@mews/routing';
import { DataTestId } from '@mews-commander/enums';
import { ContentCard, DefaultErrorBoundary } from '@mews-commander/ui';
import TemplateFetcher from '../../../app/components/TemplateFetcher';
import { getCheckedReservationsActionLogUrl } from '../../selectors';

interface ReservationActionLogProps {
    scope: string;
}

const ReservationActionLog: React.FC<ReservationActionLogProps> = ({ scope }) => {
    const resolveRoute = useResolveRoute();

    const url = useSelector((state: ApplicationState) =>
        getCheckedReservationsActionLogUrl(state, { resolveRoute, scope })
    );

    return (
        <DefaultErrorBoundary>
            <ContentCard data-test-id={DataTestId.ReservationActionLog}>
                <TemplateFetcher url={url} layout="Empty" />
            </ContentCard>
        </DefaultErrorBoundary>
    );
};

export default ReservationActionLog;
